(function() {
  // Desktop CSS only - mobile handled via JS inline styles
  var style = document.createElement('style');
  style.textContent =
    '.jc-pack-selector{margin:8px 0 16px;font-family:brandon-grotesque,Brandon Grotesque,sans-serif}' +
    '.jc-pack-selector__label{display:block;font-size:10px;font-weight:700;color:rgba(58,16,96,.4);text-transform:uppercase;letter-spacing:.12em;margin-bottom:8px}' +
    '.jc-pack-selector__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}' +
    '.jc-pack-wrap{display:flex;flex-direction:column;gap:4px}' +
    '.jc-pack-card{border:1.5px solid rgba(122,74,156,.2);border-radius:8px;padding:8px 6px;cursor:pointer;text-align:center;background:#fff;transition:border-color .15s,background .15s;user-select:none}' +
    '.jc-pack-card:hover{border-color:#7A4A9C;background:#F5F0FF}' +
    '.jc-pack-card.is-selected{border-color:#7A4A9C;border-width:2px;background:#F5F0FF}' +
    '.jc-pack-card.is-selected .jc-pack-card__units{color:#7A4A9C}' +
    '.jc-pack-card__num-group{display:block}' +
    '.jc-pack-card__units{font-size:16px;font-weight:700;color:#2a0848;line-height:1;display:block}' +
    '.jc-pack-card__unit-label{font-size:9px;font-weight:400;color:rgba(58,16,96,.45);text-transform:uppercase;letter-spacing:.06em;display:block;margin-bottom:3px}' +
    '.jc-pack-card__price{font-size:11px;font-weight:700;color:#2a0848;display:block}' +
    '.jc-pack-badge{display:block;color:#fff;font-size:8px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:3px 5px;border-radius:4px;text-align:center;width:100%;box-sizing:border-box;line-height:1.3;background:#E8724A}' +
    '.jc-pack-badge--green{background:#6BBF8E}';
  document.head.appendChild(style);

  function formatPrice(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }

  function isMobile() {
    return window.innerWidth <= 600;
  }

  function applyMobileStyles(grid) {
    if (!isMobile()) return;

    // Grid
    grid.style.cssText = 'display:flex;flex-direction:column;gap:0';

    // Each wrap
    Array.from(grid.querySelectorAll('.jc-pack-wrap')).forEach(function(wrap) {
      wrap.style.cssText = 'display:flex;flex-direction:column;gap:3px;margin-bottom:16px;width:100%';

      // Card
      var card = wrap.querySelector('.jc-pack-card');
      if (card) {
        card.style.cssText = 'display:flex;flex-direction:row;align-items:center;padding:12px 16px;width:100%;box-sizing:border-box;text-align:left';
      }

      // Num group
      var numGroup = wrap.querySelector('.jc-pack-card__num-group');
      if (numGroup) {
        numGroup.style.cssText = 'display:flex;flex-direction:column;align-items:center;margin-right:14px;min-width:44px;flex-shrink:0';
      }

      // Units
      var units = wrap.querySelector('.jc-pack-card__units');
      if (units) units.style.cssText = 'font-size:22px;line-height:1;display:block';

      // Unit label
      var unitLabel = wrap.querySelector('.jc-pack-card__unit-label');
      if (unitLabel) unitLabel.style.cssText = 'font-size:9px;margin-bottom:0;display:block';

      // Price
      var price = wrap.querySelector('.jc-pack-card__price');
      if (price) price.style.cssText = 'font-size:13px;font-weight:700;margin-left:auto;white-space:nowrap;flex-shrink:0;color:#2a0848;display:block';

      // Badge
      var badge = wrap.querySelector('.jc-pack-badge');
      if (badge) badge.style.cssText = 'display:inline-block;width:auto;border-radius:20px;padding:3px 10px;font-size:9px;text-align:left;color:#fff';
    });
  }

  var selectedIndex = 0;

  function buildPackSelector(wrapper) {
    var existing = wrapper.querySelector('.jc-pack-selector');
    if (existing) existing.remove();

    var items = wrapper.querySelectorAll('.select-popout__item');
    var legend = wrapper.querySelector('.radio__legend__option-name');
    if (!items.length || !legend || legend.innerText.trim() !== 'Packs') return;

    Array.from(items).forEach(function(item, i) {
      if (item.getAttribute('selected') === 'selected') selectedIndex = i;
    });

    var variants = (window.meta && window.meta.product && window.meta.product.variants) || [];
    var qtys = [1, 4, 8, 12];

    var packs = Array.from(items).map(function(item, i) {
      var v = variants[i] || {};
      var price = v.price || 0;
      var basePrice = variants[0] ? variants[0].price : price;
      var qty = qtys[i] || (i + 1);
      var savings = (basePrice * qty) - price;
      var rawText = item.getAttribute('value') || '';
      var freeShip = rawText.includes('GRATIS') || rawText.includes('\uD83D\uDE9A');
      var cleanLabel = rawText.replace(/\s*-?\s*\uD83D\uDE9A.*$/, '').replace(/\s*-\s*ENV[I\xCD]O.*$/i, '').trim();
      var parts = cleanLabel.split(' ');
      return {
        num: parts[0],
        unit: parts.slice(1).join(' '),
        price: formatPrice(price),
        savings: savings > 0 ? formatPrice(savings) : null,
        freeShipping: freeShip,
        item: item
      };
    });

    var container = document.createElement('div');
    container.className = 'jc-pack-selector';
    container.innerHTML = '<span class="jc-pack-selector__label">Elige tu pack</span><div class="jc-pack-selector__grid"></div>';
    var grid = container.querySelector('.jc-pack-selector__grid');

    packs.forEach(function(pack, i) {
      var wrap = document.createElement('div');
      wrap.className = 'jc-pack-wrap';

      var card = document.createElement('div');
      card.className = 'jc-pack-card' + (i === selectedIndex ? ' is-selected' : '');
      card.innerHTML =
        '<div class="jc-pack-card__num-group">' +
          '<span class="jc-pack-card__units">' + pack.num + '</span>' +
          '<span class="jc-pack-card__unit-label">' + pack.unit + '</span>' +
        '</div>' +
        '<span class="jc-pack-card__price">' + pack.price + '</span>';
      wrap.appendChild(card);

      if (pack.freeShipping || pack.savings) {
        var badge = document.createElement('span');
        badge.className = 'jc-pack-badge' + (pack.freeShipping ? ' jc-pack-badge--green' : '');
        if (pack.freeShipping && pack.savings) {
          badge.textContent = 'Ahorra ' + pack.savings + ' + Envio gratis';
        } else if (pack.freeShipping) {
          badge.textContent = 'Envio gratis';
        } else {
          badge.textContent = 'Ahorra ' + pack.savings;
        }
        wrap.appendChild(badge);
      }

      card.addEventListener('click', function() {
        selectedIndex = i;
        grid.querySelectorAll('.jc-pack-card').forEach(function(c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var anchor = pack.item.querySelector('a');
        if (anchor) anchor.click();
      });

      grid.appendChild(wrap);
    });

    ['popout-select', '.radio__legend', '.select__fieldset'].forEach(function(sel) {
      var el = wrapper.querySelector(sel);
      if (el) el.style.cssText = 'display:none!important';
    });

    wrapper.insertBefore(container, wrapper.firstChild);

    // Apply mobile inline styles immediately
    applyMobileStyles(grid);
  }

  function initAll() {
    document.querySelectorAll('.selector-wrapper').forEach(buildPackSelector);
  }

  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var isVariantFetch = typeof url === 'string' && url.includes('section_id=');
    var promise = origFetch.apply(this, arguments);
    if (isVariantFetch) {
      promise.then(function() {
        setTimeout(initAll, 100);
        setTimeout(initAll, 400);
      });
    }
    return promise;
  };

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') setTimeout(initAll, 300);

  // Re-apply on resize
  window.addEventListener('resize', function() {
    var grid = document.querySelector('.jc-pack-selector__grid');
    if (grid) applyMobileStyles(grid);
  });
})();